export type ReplayMotionMode='animated'|'static-steps'|'animated-override'

export function replayMotionMode(_systemReducedMotion:boolean,staticSteps:boolean):ReplayMotionMode{
  return staticSteps?'static-steps':'animated'
}

export function nextStaticReplayStep(current:number,completed:number){
  return Math.min(completed,current+1)
}
